class UserAddressModel {
  constructor(data) {
    this.id = data.userAddressId || data.id
    this.hasDefault = data.hasDefault
    this.lastName = data.lastName
    this.firstName = data.firstName
    this.countryCode = data.countryCode
    this.countryName = data.countryName
    this.stateCode = data.stateCode || data.provinceCode
    this.stateName = data.stateName || data.provinceName
    this.cityName = data.cityName
    this.addressLine1 = data.addressLine1 || data.address1
    this.addressLine2 = data.addressLine2 || data.address2 || ''
    this.zipCode = data.zipCode
    this.telNumber = data.telNumber || data.phone
    this.taxNo = data.taxNo
    this.houseNo = data.houseNo || ''
  }
}

UserAddressModel.createList = list =>　list.map(item => new UserAddressModel(item))

export default UserAddressModel